import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { jotaiStore } from 'shared/store';

import { netSuiteItemLineNumberState } from '../../resources/states';

export const useGetAndIncreaseItemLineNumber = () => {
    const setItemLineNumber = useSetAtom(netSuiteItemLineNumberState);

    const getAndIncreaseItemLineNumber = useCallback(() => {
        /*
         * Get the current line number from the jotai store
         * to avoid collisions in expense lines and item lines
         */
        const currentLineNumber = jotaiStore.get(netSuiteItemLineNumberState);

        setItemLineNumber(currentLineNumber + 1);

        return currentLineNumber;
    }, [setItemLineNumber]);

    return getAndIncreaseItemLineNumber;
};
